import Chip from '@mui/material/Chip';

import { ROTULOS_DE_ESTADO_DA_FONTE, type EstadoDaFonte } from '../api/tipos';

/**
 * Cor por TOKEN do design system (`ADR-0005`), nunca hex no componente.
 *
 * O pacote `@anery/design-system` ainda não tem um token de domínio para
 * `fonte.status_ingestao` (`TP-049` é posterior aos tokens existentes), e
 * esta implementação está restrita a `apps/web/**` — não cria token novo no
 * pacote. Em vez disso reaproveita `tema.palette.sla`, que já tem o
 * vocabulário genérico (`ok`/`atencao`/`estourado`/`semPrazo`) de que este
 * selo precisa: sucesso, neutro-aguardando e erro. Registrado como desvio na
 * implementação (tech-plan, `DI14`).
 */
const TOM: Record<EstadoDaFonte, 'ok' | 'atencao' | 'estourado' | 'semPrazo'> = {
  recebida: 'semPrazo',
  texto_extraido: 'ok',
  mapeada: 'ok',
  regras_extraidas: 'ok',
  em_revisao: 'atencao',
  ativa: 'ok',
  rejeitada: 'estourado',
};

export function SeloDeEstadoDaFonte({ estado }: { estado: EstadoDaFonte }): React.JSX.Element {
  return (
    <Chip
      size="small"
      label={ROTULOS_DE_ESTADO_DA_FONTE[estado]}
      sx={(tema) => {
        const tom = tema.palette.sla[TOM[estado]];
        return {
          backgroundColor: tom.fundo,
          color: tom.tinta,
          border: `1px solid ${tom.borda}`,
          fontWeight: 600,
          height: 20,
        };
      }}
    />
  );
}
